const AnjuRemixesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/anjuonline/sebii-bonerr-anju-online-remix" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-9Taw9FwAqAJ7h2ue-HyF5XA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>SEBii - BONErr</strong><br/>
                (ANJU Online! Flip)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/anjuonline/them-drugs-come-in-handy-1" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-a5DaYyGawg6ZVveE-tmzI7g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>21 Savage - X</strong><br/>
                (ANJU Online! Flip)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/anjuonline/i-can-make-a-call" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000605219989-6hjpuo-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Pusha T - Drug Dealers Anonymous</strong><br/>
                (ANJU Online! Flip)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/anjuonline/where-my-dogs-at" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-000439292301-ro4zhc-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Rick Ross - BMF</strong><br/>
                (ANJU Online! Flip)
              </p>
            </a>
          </div>    

        </div>
      </>
    );
  };
  export default AnjuRemixesStatic;